import React from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { useSWRConfig } from 'swr'
import { ReloadIcon } from '@radix-ui/react-icons'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'

const Layout = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { mutate } = useSWRConfig()

  const handleRefresh = () => {
    mutate(() => true)
  }

  return (
    <div className="flex flex-col">
      <div className="mb-4 flex items-center gap-4">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={() => navigate(-1)}
          title="返回"
          aria-label="返回"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <h1 className="text-3xl font-bold tracking-tight">模版-{id}</h1>
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={handleRefresh}
          title="刷新"
        >
          <ReloadIcon className="h-4 w-4" />
        </Button>
      </div>
      <Outlet />
    </div>
  )
}

export default Layout
